/*
  Rotates the promo strip: one message visible, swapped for the next every
  data-interval milliseconds.

  The messages are all in the markup, stacked in one grid cell (see
  pujalane-card-style.css section 24); this only moves the is-active class.
  The outgoing message gets is-leaving for the length of the transition so it
  exits upwards while the next one rises from below.

  Without JS the first message stays put.
*/
class PujalaneMarquee extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.pl-marquee__item'));
    if (this.items.length < 2) return;

    this.index = Math.max(
      0,
      this.items.findIndex((item) => item.classList.contains('is-active'))
    );
    this.interval = Number(this.dataset.interval) || 5000;

    // Hold a message while it is being read or used. Hover only where hover
    // exists: on a touch screen it would stick after a tap and stop the strip.
    if (window.matchMedia('(hover: hover)').matches) {
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
    }
    this.addEventListener('focusin', (event) => {
      this.stop();
      const item = event.target.closest('.pl-marquee__item');
      if (item) this.show(this.items.indexOf(item));
    });
    this.addEventListener('focusout', () => this.start());

    // Theme editor: selecting a message block brings it up and holds it.
    this.addEventListener('shopify:block:select', (event) => {
      this.stop();
      this.show(this.items.indexOf(event.target));
    });
    this.addEventListener('shopify:block:deselect', () => this.start());

    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  start() {
    this.stop();
    this.timer = setInterval(() => {
      // A background tab would otherwise queue up swaps nobody saw.
      if (document.hidden) return;
      this.show((this.index + 1) % this.items.length);
    }, this.interval);
  }

  stop() {
    clearInterval(this.timer);
  }

  show(next) {
    if (next < 0 || next === this.index) return;

    const previous = this.items[this.index];
    previous.classList.remove('is-active');
    previous.classList.add('is-leaving');
    // Matches the transition in section 24, with a little slack.
    setTimeout(() => previous.classList.remove('is-leaving'), 450);

    this.items[next].classList.remove('is-leaving');
    this.items[next].classList.add('is-active');
    this.index = next;
  }
}

if (!customElements.get('pujalane-marquee')) {
  customElements.define('pujalane-marquee', PujalaneMarquee);
}
